import { ReactNode } from "react";

import styles from "./DialogButtonGroupV2.module.scss";

type DialogButtonGroupPropsV2 = {
  children: ReactNode;
};

export const DialogButtonGroupV2 = ({ children }: DialogButtonGroupPropsV2) => (
  <div className={styles.buttonGroup}>{children}</div>
);
